import {
  __glob
} from "./chunk-HS5PO5ZQ.js";

// import("../plots/**/*.js") in plots/importPlot.js
var globImport_plots_js = __glob({
  "../plots/controls.btns.js": () => import("./controls.btns-BYM4DON4.js"),
  "../plots/controls.config.js": () => import("./controls.config-Y7NGPB5K.js"),
  "../plots/controls.js": () => import("./controls-US3ID2ZR.js"),
  "../plots/dictionary.js": () => import("./dictionary-LFOSXJGH.js"),
  "../plots/gb/test/genomeBrowser.spec.js": () => import("./genomeBrowser.spec-3U6KE3MK.js"),
  "../plots/geneExpression.js": () => import("./geneExpression-ECXW22H6.js"),
  "../plots/geneORA.js": () => import("./geneORA-BQZ4XYJH.js"),
  "../plots/geneset.js": () => import("./geneset-HMADFO7Z.js"),
  "../plots/hierCluster.js": () => import("./hierCluster-JUJ7C7TQ.js"),
  "../plots/importPlot.js": () => import("./importPlot-QSWJBDWH.js"),
  "../plots/matrix.js": () => import("./matrix-74JSSVR5.js"),
  "../plots/matrix/hierCluster.config.js": () => import("./hierCluster.config-RSSBKO6G.js"),
  "../plots/matrix/hierCluster.interactivity.js": () => import("./hierCluster.interactivity-PRIWN65K.js"),
  "../plots/matrix/hierCluster.js": () => import("./hierCluster-N6B4L6FW.js"),
  "../plots/matrix/hierCluster.renderers.js": () => import("./hierCluster.renderers-3RHXOHZ5.js"),
  "../plots/matrix/matrix.cells.js": () => import("./matrix.cells-WYCIMZRW.js"),
  "../plots/matrix/matrix.cluster.js": () => import("./matrix.cluster-RH4BOM5F.js"),
  "../plots/matrix/matrix.config.js": () => import("./matrix.config-5SNEP3B4.js"),
  "../plots/matrix/matrix.data.js": () => import("./matrix.data-3H4GFMQK.js"),
  "../plots/matrix/matrix.dom.js": () => import("./matrix.dom-2SA43BPT.js"),
  "../plots/matrix/matrix.groups.js": () => import("./matrix.groups-FGLRK6IT.js"),
  "../plots/matrix/matrix.interactivity.js": () => import("./matrix.interactivity-GSV45F2N.js"),
  "../plots/matrix/matrix.js": () => import("./matrix-YARPFYCU.js"),
  "../plots/matrix/matrix.layout.js": () => import("./matrix.layout-BMH4V36B.js"),
  "../plots/matrix/matrix.legend.js": () => import("./matrix.legend-5OVHDE6Q.js"),
  "../plots/matrix/matrix.renderers.js": () => import("./matrix.renderers-DENF4NZ6.js"),
  "../plots/matrix/matrix.serieses.js": () => import("./matrix.serieses-D7XPW5L4.js"),
  "../plots/matrix/matrix.sort.js": () => import("./matrix.sort-XQEOXSEG.js"),
  "../plots/matrix/matrix.sorterUi.js": () => import("./matrix.sorterUi-J6PRUT6J.js"),
  "../plots/matrix/test/hierCluster.integration.spec.js": () => import("./hierCluster.integration.spec-YC6B3ID2.js"),
  "../plots/matrix/test/matrix.integration.spec.js": () => import("./matrix.integration.spec-4DQIRQQO.js"),
  "../plots/matrix/test/matrix.sort.unit.spec.js": () => import("./matrix.sort.unit.spec-HGII2SCC.js"),
  "../plots/matrix/test/matrix.sorterUi.unit.spec.js": () => import("./matrix.sorterUi.unit.spec-TNRATMUJ.js"),
  "../plots/matrix/test/matrix.unit.spec.js": () => import("./matrix.unit.spec-LBMDCANX.js"),
  "../plots/matrix/test/oncomatrix.spec.js": () => import("./oncomatrix.spec-O6U52E22.js"),
  "../plots/plot.brainImaging.js": () => import("./plot.brainImaging-LRQYKMLQ.js"),
  "../plots/plot.disco.js": () => import("./plot.disco-NCTBMD2W.js"),
  "../plots/plot.ssgq.js": () => import("./plot.ssgq-CL3TGZ55.js"),
  "../plots/singleCellPlot.js": () => import("./singleCellPlot-AU5K4M7J.js"),
  "../plots/stattable.js": () => import("./stattable-JCH2WPS6.js"),
  "../plots/survival/test/survival.integration.spec.js": () => import("./survival.integration.spec-C7OJC4AG.js"),
  "../plots/table.js": () => import("./table-FKLXVILD.js"),
  "../plots/test/expclust.gdc.spec.js": () => import("./expclust.gdc.spec-TFJEXEAA.js"),
  "../plots/test/summary.integration.spec.js": () => import("./summary.integration.spec-IFGDIEMW.js"),
  "../plots/volcano/test/testData.js": () => import("./testData-DRM5HWQB.js")
});

// plots/importPlot.js
async function importPlot(chartType, notFoundMessage = "") {
  switch (chartType) {
    case "aggregateMatrix":
      return await import("./AggregateMatrix-U3NZSNL6.js");
    case "aggMatrixInput":
      return await import("./AggMatrixInput-254IEQYB.js");
    case "animatedBubbleChart":
      return await import("./animatedBubbleChart-IQBJBHPP.js");
    case "brainImaging":
      return await import("./brainImaging-6WLB6DWG.js");
    case "brainRegions":
      return await import("./brainRegions-EVHXPPL5.js");
    case "barchart":
      return await import("./barchart-WF5VWDCV.js");
    case "boxplot":
      return await import("./BoxPlot-POSL2ZLS.js");
    case "bubbleHeatmap":
      return await import("./bubbleHeatmap-WZX7MLQF.js");
    case "cellTypeBubbleHeatmap":
      return await import("./cellTypeBubbleHeatmap-3XY3U7EO.js");
    case "correlationVolcano":
      return await import("./CorrelationVolcano-YZ6ACP5D.js");
    case "cuminc":
      return await import("./Cuminc-SJVFK4VX.js");
    case "dataDownload":
      return await import("./dataDownload-4YQHUJQX.js");
    case "DEinput":
      return await import("./DEinput-H25PS4QT.js");
    case "dictionary":
      return await import("./dictionary-LFOSXJGH.js");
    case "differentialAnalysis":
      return await import("./DifferentialAnalysis-4J75UMV7.js");
    case "Disco":
      return await import("./Disco-IXGGKIEI.js");
    case "dmr":
      return await import("./DmrPlot-SJWHTSMB.js");
    case "facet":
      return await import("./facet-AWDU4CCU.js");
    case "GeneExpInput":
      return await import("./GeneExpInput-3KFGQEAY.js");
    case "geneRanking":
      return await import("./geneRanking-GXRSXHIN.js");
    case "genomeBrowser":
      return await import("./GB-KPF7BZFQ.js");
    case "geomap":
      return await import("./Geomap-R7Q3T3DZ.js");
    case "grin2":
      return await import("./grin2-AJAXI4O4.js");
    case "gsea":
      return await import("./GSEA-BMVTJ6B7.js");
    case "imagePlot":
      return await import("./imagePlot-DSG4WJOG.js");
    case "numericDictTermCluster":
      return await import("./numericDictTermCluster-YTAMQDWZ.js");
    case "profileBarchart2":
      return await import("./barchart2-3HGZ5Q2B.js");
    case "profileForms":
      return await import("./profileForms-Z4Y55OQY.js");
    case "profilePlot":
      return await import("./profilePlot-LMDZVOJK.js");
    case "profilePolar2":
      return await import("./polar2-ABI2UJNC.js");
    case "profileRadar2":
      return await import("./radar2-OXUS5DLT.js");
    case "profileRadarFacility2":
      return await import("./radarFacility2-VOUNCM6A.js");
    case "proteinView":
      return await import("./proteinView-UYMM76WH.js");
    case "proteomeAbundance":
      return await import("./proteomeAbundance-NH3Y4YC7.js");
    case "proteomeCohortCompare":
      return await import("./proteomeCohortCompare-5GFBARC5.js");
    case "ProteomeInput":
      return await import("./ProteomeInput-JZ6MKE7L.js");
    case "regression":
      return await import("./Regression-QBR2VYHT.js");
    case "report":
      return await import("./report-PBRD2KBN.js");
    case "runChart2":
    //See frequencyChart
    case "frequencyChart":
      return await import("./RunChart2-UKN6M5M5.js");
    case "sampleView":
      return await import("./sampleView-7HWFZCHE.js");
    case "sampleScatter":
      return await import("./scatter-TBGEXELG.js");
    case "sc":
      return await import("./SC-COHN7DMJ.js");
    case "studyCatalog":
      return await import("./studyCatalog-FDB7D26M.js");
    case "summarizeCnvGeneexp":
      return await import("./summarizeCnvGeneexp-KNW23YAI.js");
    case "summarizeGeneexpSurvival":
      return await import("./summarizeGeneexpSurvival-H57GGCXL.js");
    case "summarizeMutationDiagnosis":
      return await import("./summarizeMutationDiagnosis-R6YWQ4LQ.js");
    case "summarizeMutationSurvival":
      return await import("./summarizeMutationSurvival-Q6WKBNPD.js");
    case "summarizeMutationCnv":
      return await import("./summarizeMutationCnv-RBBDE27N.js");
    case "summaryInput":
      return await import("./summaryInput-TYIKTBO3.js");
    case "summary":
      return await import("./summary-AL3GEK3G.js");
    case "survival":
      return await import("./survival-HXJCMNCG.js");
    case "table":
      return await import("./table-FKLXVILD.js");
    case "violin":
      return await import("./Violin-SDUSKIEX.js");
    case "volcano":
      return await import("./Volcano-KON4MOIM.js");
    case "wsi":
      return await import("./Wsi-SJC56PRR.js");
    default:
      if (notFoundMessage) throw notFoundMessage;
      return await globImport_plots_js(`../plots/${chartType}.js`);
  }
}

export {
  importPlot
};
//# sourceMappingURL=chunk-CCYVGZGI.js.map
